import axios from 'axios';
import { baseUrl } from '@/config/app';
import { hasToken, getToken, removeToken } from '@/utils/cookies';

// Create an Axios instance
const api = axios.create({
  baseURL: baseUrl.api,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Request Interceptor for setting Authorization headers if needed
api.interceptors.request.use(
  (config) => {
    if (hasToken()) {
      config.headers['Authorization'] = `Bearer ${getToken()}`;
    } else {
      if (hasToken(true)) {
        config.headers['Authorization'] = `Bearer ${getToken(true)}`;
      }
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response Interceptor for handling errors globally
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // Handle 429 Rate Limiting
    if (error.response && error.response.status === 429) {
      alert(`Rate Limit Exceeded: ${error.response.data.message}`);
      console.error(
        'Rate limit exceeded:',
        error.response.data.message || 'Too many requests'
      );
    }

    // Handle global errors here (e.g., redirect to login on 401)
    if (error.response && error.response.status === 401) {
      if (error.response.data.message == 'Unauthenticated.') {
        removeToken();
        removeToken(true);
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
